// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactErrorBoundary = require("react-error-boundary");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let DuplicateQuietPropertyError = require("./DuplicateQuietPropertyError.bs.js");
let PropertyAddressValidationCallout = require("./PropertyAddressValidationCallout.bs.js");
let DuplicateBroadcastRentalPropertyError = require("./DuplicateBroadcastRentalPropertyError.bs.js");
let DuplicateBroadcastForSalePropertyError = require("./DuplicateBroadcastForSalePropertyError.bs.js");
let PropertyAddressValidationDuplicatePropertyError_property_graphql = require("../../../../__generated__/PropertyAddressValidationDuplicatePropertyError_property_graphql.bs.js");

let convertFragment = PropertyAddressValidationDuplicatePropertyError_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyAddressValidationDuplicatePropertyError_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyAddressValidationDuplicatePropertyError_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyAddressValidationDuplicatePropertyError_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyAddressValidationDuplicatePropertyError_property_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyAddressValidationDuplicatePropertyError$PropertyAddressValidationDuplicatePropertyError$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(PropertyAddressValidationDuplicatePropertyError_property_graphql.node, convertFragment, props.property);
  switch (property.__typename) {
    case "EditableBroadcastForSaleProperty" :
      return JsxRuntime.jsx(DuplicateBroadcastForSalePropertyError.make, {
        property: property.fragmentRefs
      });
    case "EditableBroadcastRentalProperty" :
      return JsxRuntime.jsx(DuplicateBroadcastRentalPropertyError.make, {
        property: property.fragmentRefs
      });
    case "EditableQuietProperty" :
      return JsxRuntime.jsx(DuplicateQuietPropertyError.make, {
        property: property.fragmentRefs
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected editable property: ` + property._0);
  }
}

let WithoutErrorBoundary = {
  make: PropertyAddressValidationDuplicatePropertyError$PropertyAddressValidationDuplicatePropertyError$WithoutErrorBoundary
};

let PropertyAddressValidationDuplicatePropertyError = {
  WithoutErrorBoundary: WithoutErrorBoundary
};

function PropertyAddressValidationDuplicatePropertyError$ErrorComponent(props) {
  return JsxRuntime.jsx(PropertyAddressValidationCallout.make, {
    heading: "There was an error validating the address",
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("p", {
        children: "We encountered and error while validating the address. Please try re-entering the address above"
      }),
      className: "leading-normal"
    }),
    icon: "Error"
  });
}

let ErrorComponent = {
  make: PropertyAddressValidationDuplicatePropertyError$ErrorComponent
};

function PropertyAddressValidationDuplicatePropertyError$1(props) {
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(PropertyAddressValidationDuplicatePropertyError$ErrorComponent, {}),
    children: JsxRuntime.jsx(PropertyAddressValidationDuplicatePropertyError$PropertyAddressValidationDuplicatePropertyError$WithoutErrorBoundary, {
      property: props.property
    })
  });
}

let make = PropertyAddressValidationDuplicatePropertyError$1;

exports.Fragment = Fragment;
exports.PropertyAddressValidationDuplicatePropertyError = PropertyAddressValidationDuplicatePropertyError;
exports.ErrorComponent = ErrorComponent;
exports.make = make;
/* react/jsx-runtime Not a pure module */
